import { Directive, Input } from '@angular/core';
import {
  NG_VALIDATORS,
  AbstractControl,
  ValidatorFn,
  Validator,
  ValidationErrors,
  FormGroup,
  UntypedFormArray
} from '@angular/forms';

@Directive({
    selector: '[appUniqueDose]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: UniqueDoseDirective,
            multi: true
        }
    ],
    standalone: false
})
export class UniqueDoseDirective implements Validator {

  constructor() {}

  /** Control should not share the same Dose ID with any other Selected Drug */
  validate(control: AbstractControl): ValidationErrors {
    return this.uniqueDoseValidator(control);
  }

  private uniqueDoseValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const formValues = JSON.stringify((control.parent.parent as UntypedFormArray).value);
    const doseValueRegex = new RegExp(`\"selectedDosage\":\"${control.value}\"`, 'g');
    const occurrences = formValues.match(doseValueRegex) || [];
    return occurrences.length > 1 ? { 'dose-not-unique': true } : null;
  }
}
